import { useTenant } from "../lib/tenant.js";
import { PageTemplateView } from "../templates/PageTemplateView.js";
import { useBoxesContent } from "../templates/pages/boxes/useBoxesContent.js";
import { storefrontTemplateOf } from "../templates/registry.js";

/** GET /v1/boxes, laid out by the storefront template this environment chose. */
export function BoxesPage() {
  const { config } = useTenant();
  return (
    <PageTemplateView template={storefrontTemplateOf(config).boxes} content={useBoxesContent()} />
  );
}
